<template>
	<div class="layout">
		<div class="layout-navigator">
			<div class="layout-logo">
				<img src="../../assets/logo.png">
				河北省司法鉴定案<br>
				件受理管理系统
			</div>
			<div class="layout-navigation"></div>
			<div class="layout-time">
				<el-link href="http://hbsfjd.intcont.bjzjtp.com/login.html" target="_blank">河北司法鉴定文书无纸化系统</el-link>
				<br>
				{{timeStr}}
				<br>
				技术支持：{{supportEmail}}
			</div>
		</div>
		<div class="layout-view">
			<div class="layout-title">
				<div class="layout-name">
					<img src="../../assets/icon_top_menu@2x.png">
					{{routerObj.name}}
				</div>
				<div class="layout-search">
					<el-input placeholder="搜索编号、委托人" v-model="keyword" clearable>
						<el-button slot="append" icon="el-icon-search" @click="doSearch(keyword)"></el-button>
					</el-input>
				</div>
				<div class="layout-avatar">
					<div class="layout-avatar-in">
						<img :src="user.avatar" v-if="user.avatar!=''">
						<img src="../../assets/judicial.png" v-if="user.avatar==''">
					</div>
					{{user.name}}
				</div>
				<div class="layout-logout" @click="changePass()">
					<div class="layout-icon-back">
						<i class="el-icon-lock"></i>
					</div>
				</div>
				<div class="layout-logout" @click="doLogout">
					<div class="layout-icon-back">
						<img src="../../assets/icon_top_exit@2x.png">
					</div>
				</div>
			</div>
			<div class="layout-page">
				<router-view ref="queryData"></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'layout',
		data() {
			return {
				timeStr: '',
				routerObj: {
					name: ''
				},
				user: {
					avatar: '',
					name: ''
				},
				keyword: '',
				supportEmail:'support@sfjdzx.org.cn'
			};
		},
		computed:{
			getkeyword(){
				return this.keyword
			}
		},
		watch:{
			keyword:function(a,b){
				this.doSearch(a)
			}
		},
		methods: {
			...mapMutations(['logout']),
			doLogout() {
				this.$confirm('请问是否确认退出登录？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.resetHeader()
					this.$message({
						type: 'success',
						message: '退出登录成功',
						duration: 1500,
						onClose: () => {
							this.logout()
						}
					});
				}).catch(() => {});
			},
			doSearch(keyword) {
				this.$refs.queryData.fetchDataWithKeyword(keyword)
			},
			getDate(){
				let date = new Date()
				let year = date.getFullYear()
				let month = date.getMonth()+1
				let day = date.getDate()
				let hour = date.getHours()
				let minute = date.getMinutes()
				this.timeStr = year+'年'+month+'月'+day+'日 '+hour+':'+minute
			},
			changePass(){
				this.$router.push({
					path:'/forget'
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.user = this.$store.state.userInfo
			this.getDate()
			let interval = setInterval(()=>{
				this.getDate()
			},60000)
			document.onkeydown = (event)=>{
				let e = event || window.event || arguments.callee.caller.arguments[0]
				if(e&&e.keyCode == 13){
					this.doSearch(this.keyword)
				}
			}
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.layout {
		width: 100vw;
		height: 100vh;
		display: flex;
		justify-content: space-between;

		.layout-navigator {
			width: 220px;
			height: 100%;
			background: #2c3451;
			position: relative;
		
			.layout-logo {
				width: 100%;
				height: 100px;
				display: flex;
				align-items: center;
				color: #E3E3E3;
				padding: 0px 15px;
				box-sizing: border-box;
		
				img {
					width: 40px;
					height: 40px;
					margin-right: @vue-spacing-row-sm;
				}
			}
		
			.layout-navigation {
				width: 100%;
				height: calc(100% - 200px);
				overflow: auto;
				padding: 0px 15px;
				box-sizing: border-box;
		
				.layout-item {
					width: 100%;
					height: 50px;
					margin-bottom: 12px;
		
					a {
						width: 100%;
						height: 100%;
						display: flex;
						align-items: center;
						color: #F0F0F0;
						font-size: 14px;
						border-radius: 12px;
						padding-left: 10px;
						box-sizing: border-box;
		
						img {
							width: 26px;
							margin-right: 12px;
						}
					}
		
					.layout-item-select {
						background: #313f6e;
					}
				}
			}
		
			.layout-time {
				width: 100%;
				height: 100px;
				line-height: 30px;
				text-align: center;
				color: #FFFFFF;
				font-size: @vue-font-size-min;
		
				.el-link {
					color: @vue-text-color-inverse;
					font-size: @vue-font-size-sm - 2;
				}
			}
		}

		.layout-view {
			width: calc(100vw - 220px);
			height: 100%;

			.layout-title {
				width: 100%;
				height: 70px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 0px 15px;
				box-sizing: border-box;
				border-bottom: 1px solid #D3D3D3;

				.layout-name {
					width: 30%;
					height: 100%;
					display: flex;
					align-items: center;
					font-size: 16px;
					color: #464F6D;
					font-weight: bold;

					img {
						width: 22px;
						height: 22px;
						margin-right: 4px;
					}
				}

				.layout-search {
					width: 45%;
					height: 100%;
					display: flex;
					justify-content: flex-end;
					align-items: center;

					.el-input {
						width: 400px;
					}
				}

				.layout-avatar {
					width: 15%;
					height: 100%;
					display: flex;
					align-items: center;
					font-size: 14px;
					color: #464F6D;
					font-weight: bold;
					padding-left: 20px;
					box-sizing: border-box;

					.layout-avatar-in {
						width: 55px;
						height: 55px;
						border-radius: 50%;
						overflow: hidden;
						margin-right: 12px;

						img {
							width: 100%;
							height: 100%;
						}
					}
				}

				.layout-logout {
					width: 5%;
					height: 30px;
					display: flex;
					justify-content: center;

					.layout-icon-back {
						width: 30px;
						height: 30px;
						background: #F0F0F0;
						border-radius: 50%;
						display: flex;
						justify-content: center;
						align-items: center;

						img {
							width: 20px;
						}
					}
				}

				.layout-logout:hover {
					cursor: pointer;

					.layout-icon-back {
						background: #B3D8FF;
					}
				}
			}

			.layout-page {
				width: 100%;
				height: calc(100vh - 70px);
				overflow: auto;
			}
		}
	}
</style>
